// components/ThumbsUpLoader.js
import React from 'react';
import './HandLoader.css'; // Put the CSS you shared here

const HandLoader = () => {
  return (
    <div className="🤚">
      <div className="👉"></div>
      <div className="👉"></div>
      <div className="👉"></div>
      <div className="👉"></div>
      <div className="🌴"></div>		
      <div className="👍"></div>
    </div>
  );
};

export default HandLoader;
